(function() {
    setTimeout(function() {
        ['HeatmapSessionRecording'].forEach(function(src) {
            let script = document.createElement('script');
            script.src = 'https://wa.versicherungen.check24.de/plugins/' + src + '/tracker.min.async.js' ;
            script.async = true;
            document.head.appendChild(script);
        });
    }, 0);

    window._paq = window._paq || [];
    window._paq.push(['HeatmapSessionRecording::enable']);
})();
